export default __webpack_public_path__ + "static/media/header_policy.74ea6f39.jpg";